/** 
 * Update the title tag in head 
 * @param {string} title
 */
export function updateTitle(title) {
  const tag = document.querySelector('title');
  tag.textContent = title;
}
